import * as React from "react";

const SvgComponent = ({ bg = "transparent", color = "var(--filter-bar-btn-border)", stroke = "var(--filter-bar-btn-border)", ...props }) => (
  <svg
    width={30}
    height={30}
    fill={bg}
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <g opacity={0.6} fill={color}>
      <path d="M20.932 9.354a.18.18 0 0 0-.024.031l-.744 1.271a.183.183 0 0 1-.16.087l-.263-.01h-.02a1.465 1.465 0 0 1-.916-.624.168.168 0 0 1 0-.183c.183-.264.733-1.034.861-1.433.157-.458-.253-.485-.3-.487h-.01a2.54 2.54 0 0 0-1.758.55c-.766.639-.971 1.527-.984 2.469a1.887 1.887 0 0 1-.558 1.39c-.162.161-4.153 4.147-4.518 4.548a1.666 1.666 0 0 1-1.212.517 2.308 2.308 0 0 0-1.462.526c-.458.42-.641.653-.824 1.472-.167.746.24 1.466.313 1.585a.162.162 0 0 0 .028.033c.34.324.503.04.503.04l.804-1.244a.172.172 0 0 1 .198-.073l.67.218a.16.16 0 0 1 .068.042l.239.251c.046.05.057.122.029.183-.175.38-.394.737-.654 1.064-.383.47-.062.629 0 .653h.014c.206.108 1.504.084 2.129-.792.625-.875.51-1.33.518-1.996 0-.625.519-1.057.581-1.108l.013-.013c.183-.183 3.766-3.772 4.47-4.5.703-.73 1.203-.63 1.245-.622.055 0 .692.105 1.128-.073.436-.178 1.248-.938 1.555-1.747.308-.81-.113-1.671-.335-2.085-.194-.37-.55-.026-.624.06Z" />
      <path d="m14.057 13.48-1.873-1.823-.706-1.583-2.407-1.357-.705.705 1.271 2.612 1.239.414 2.08 2.03 1.101-.999ZM17.145 15.826l-1.582 1.583a.38.38 0 0 0 0 .535l3.514 3.515a.38.38 0 0 0 .535 0l1.612-1.612a.38.38 0 0 0 0-.539l-3.544-3.48a.38.38 0 0 0-.535-.002Z" />
    </g>
  </svg>
);

export default SvgComponent;
